// Match the compass crest in scripts/medals/finisher.mjs.
export const FINISHER_OUTLINE = `${Array.from({ length: 16 }, (_, i) => {
  const angle = Math.PI / 2 + (i * Math.PI) / 8;
  const radius = (i % 2 ? 0.88 : i % 4 ? 1 : 1.08) * 74;
  return `${i ? "L" : "M"}${100 + Math.cos(angle) * radius} ${96 - Math.sin(angle) * radius}`;
}).join(" ")} Z`;
export const FINISHER_WINDOW = "M100 26 A70 70 0 1 1 100 166 A70 70 0 1 1 100 26 Z";

export function FinisherArtwork({
  metal,
  light,
  enamel,
}: {
  metal: string;
  light: string;
  enamel: string;
}) {
  return (
    <g>
      <g fill={metal} stroke={light} strokeWidth={0.6}>
        {[-1, 1].map((side) => (
          <g key={side}>
            <path
              d={`M${100 + side * 27} 132 Q${100 + side * 54} 101 ${100 + side * 41} 69`}
              fill="none"
              strokeWidth={1.3}
            />
            {[0, 1, 2, 3, 4].map((step) => (
              <g key={step}>
                {[-1, 1].map((direction) => {
                  const x =
                    100 + side * (0.59 + 0.055 * Math.sin(step * 0.8) + direction * 0.035) * 74;
                  const y = 96 - (-0.3 + step * 0.135) * 74;
                  return (
                    <ellipse
                      key={direction}
                      cx={x}
                      cy={y}
                      rx={2}
                      ry={5.5}
                      transform={`rotate(${-side * direction * 43} ${x} ${y})`}
                    />
                  );
                })}
              </g>
            ))}
          </g>
        ))}
        <path d="M100 23 L102 28 L107 30 L102 32 L100 37 L98 32 L93 30 L98 28 Z" fill={light} />
      </g>
      <path
        d="M56 116 L144 116 L149 128 L144 140 L56 140 L51 128 Z"
        fill={metal}
        stroke={light}
        strokeWidth={1.5}
      />
      <path d="M59 119 L141 119 L145 128 L141 137 L59 137 L55 128 Z" fill={enamel} />
      <text
        x={100}
        y={132}
        textAnchor="middle"
        fontSize={9}
        fontWeight="700"
        letterSpacing={1.7}
        fill={light}
      >
        FINISHER
      </text>
    </g>
  );
}
